import React from 'react';
import { useListContext } from 'react-admin';

export const LengthField = (props: any) => {
  const { ids, loaded } = useListContext(props);
  return loaded ? <div>Count: {ids.length}</div> : null;
};
